export default "__VITE_ASSET__4fee30a6__"